<template>
    <div v-if="!emailSubmitted">
        <SignupForm @submitted="onSubmitted"/>
        <InfoModal
            v-if="refererInfo"
            ref="infoModal"
            :logo="refererInfo.logo"
            :title="$t(refererInfo.title)"
            :description="$t(refererInfo.description)"
        />
    </div>
    <SignupConfirmation v-else :registeredEmail="emailSubmitted" />
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import SignupForm from '../components/signup/SignupForm.vue';
import SignupConfirmation from '../components/signup/SignupConfirmation.vue';
import InfoModal from '../components/InfoModal.vue';

type RefererInfo = {
    title?: string;
    description?: string;
    logo?: string;
};

@Component({ components: { InfoModal, SignupForm, SignupConfirmation } })
export default class SignupView extends Vue {

    emailSubmitted: string | null = null;

    $refs!: {
        infoModal?: { open?: () => void };
    };

    mounted(): void {
        // DD-4E98 - On the signup page the referer info modal is shown on signup when:
        // 1) whitelabels's referer_info sources is null (always show)
        //         or when it contains the current source query param,
        // and
        // 2) at least one of title, description, or logo is set
        const refererInfo = this.$whitelabel.login.signup?.referer_info;
        if (
            refererInfo
            && (refererInfo.sources === null || refererInfo.sources?.includes(this.$route.query.source))
        ) {
            this.$refs.infoModal?.open?.();
        }
    }

    onSubmitted(email: string): void {
        this.emailSubmitted = email;
    }

    get refererInfo(): RefererInfo | null {
        if (
            !this.$whitelabel.login.signup?.referer_info
            || (
                !this.$whitelabel.login.signup.referer_info.title
                && !this.$whitelabel.login.signup.referer_info.description
                && !this.$whitelabel.login.signup.referer_info.logo_url
            )
        ) {
            return null;
        }

        return {
            title: this.$whitelabel.login.signup.referer_info.title ?? undefined,
            description: this.$whitelabel.login.signup.referer_info.description ?? undefined,
            logo: this.$whitelabel.login.signup.referer_info.logo_url ?? undefined,
        };
    }

}
</script>
